import apiCall from "../utils/apiCall";

export default class AuthService {
  static verifyAccessToken = async (payload) => {
    return await apiCall(`/api/Login`, "POST", payload);
  };
}
